import * as React from 'react';
import LocalizationService from '../../Services/Services.Secondary/Localization/LocalizationService';
import { Constants } from './Constants';
import { ServiceHealthV2 } from './Models/ServiceHealth';
import { Helper } from './Utilities/Helper';
import { ServiceHealthHelper } from './Utilities/ServiceHealthHelper';

let Constant = Constants.getInstance();

const resx = LocalizationService.getInstance();
let ViewMore_text = resx.getLocalizedResource('ViewMore_text');
let Showless_text = resx.getLocalizedResource('Showless_text');
let Hidden_text = resx.getLocalizedResource('Hidden_text');
let ViewMoreButtonServiceAnnouncementMessage_text = resx.getLocalizedResource(
  'ViewMoreButtonServiceAnnouncementMessage_text'
);
let ShowLessButtonServiceAnnouncementMessage_text = resx.getLocalizedResource(
  'ShowLessButtonServiceAnnouncementMessage_text'
);
let CurrentServiceStatus_text = resx.getLocalizedResource('CurrentServiceStatus_text');

interface IServiceHealthStatusProps {
  service: ServiceHealthV2;
  level: number;
  adminRoute: boolean;
  parentId?: string;
  showEditServiceModal?: (e: React.MouseEvent<HTMLAnchorElement>, serviceId: string, parent: string) => void;
}

interface IServiceHealthStatusState {
  showFullStatusDescription: boolean;
}

class ServiceHealthStatus extends React.Component<IServiceHealthStatusProps, IServiceHealthStatusState> {
  constructor(props: IServiceHealthStatusProps) {
    super(props);

    this.state = {
      showFullStatusDescription: false,
    };
  }

  private toggleServiceHealthNotesView = () => {
    let showFullStatusDescription = this.state.showFullStatusDescription;
    this.setState({ showFullStatusDescription: !showFullStatusDescription });
  };

  public getName = (service: ServiceHealthV2) => {
    if (Constant.ServiceHealthIds.has(service.id)) {
      let nameKey = 'ServiceHealthName_' + service.id;
      let name = resx.getLocalizedResource(nameKey);
      if (name !== nameKey) {
        return name;
      }
    }
    return service.name;
  };

  public render() {
    //TODO: move styling to CSS
    const fontWeightValue = this.props.level > 0 ? 400 : 500;

    let displayStatus =
      !this.props.service.children || (this.props.service.children && this.props.service.children.length < 1)
        ? true
        : false;
    let rowColor = displayStatus ? '' : '#EEEBEB';

    const tableRow = (
      <tr key={this.props.service.id} style={{ backgroundColor: rowColor }}>
        {(() => {
          if (this.props.adminRoute && displayStatus && !Helper.isEmptyOrSpaces(this.props.parentId ?? '')) {
            return (
              <td
                style={{ paddingLeft: '12px', fontWeight: fontWeightValue, paddingTop: '10px', paddingBottom: '10px' }}
              >
                {!this.props.service.visible && <i style={{ fontWeight: 200 }}>{Hidden_text} </i>}
                <a
                  data-toggle="tab"
                  onClick={e =>
                    this.props.showEditServiceModal &&
                    this.props.showEditServiceModal(e, this.props.service.id, this.props.parentId ?? '')
                  }
                >
                  {this.props.service.name}
                </a>
              </td>
            );
          } else {
            return (
              <td
                style={{ paddingLeft: '12px', fontWeight: fontWeightValue, paddingTop: '10px', paddingBottom: '10px' }}
              >
                {this.getName(this.props.service)}
              </td>
            );
          }
        })()}
        <td style={{ paddingTop: '8px', paddingBottom: '10px' }}>
          {displayStatus && (
            <div className="col-xs-2" style={{ padding: '0' }}>
              <div className="win-icon-composite serviceHealthTableIconSize">
                <span
                  className={ServiceHealthHelper.getStatusIconOuter(this.props.service.status)}
                  role="img"
                  aria-label={CurrentServiceStatus_text + this.props.service.status}
                ></span>
                <span className={ServiceHealthHelper.getStatusIconInner(this.props.service.status)}></span>
              </div>
            </div>
          )}
        </td>
        <td style={{ paddingTop: '10px', paddingBottom: '10px', marginRight: '6px' }}>
          {(() => {
            if (!displayStatus) return <td></td>;
            else if (
              this.props.service.status !== Constant.HealthStatus.Good &&
              this.props.service.statusDescription.length > 90
            ) {
              return (
                <div>
                  {/* this is displaying the status notes for the service with the show less/view more control */}
                  {!this.state.showFullStatusDescription && (
                    <td>
                      {' '}
                      {this.props.service.statusDescription.substr(
                        0,
                        this.props.service.statusDescription.substring(0, 120).lastIndexOf(' ')
                      )}
                      <div style={{ display: 'inline' }}>
                        <button
                          id="viewMoreButton"
                          aria-label={ViewMoreButtonServiceAnnouncementMessage_text}
                          style={{ padding: 0, border: 'none' }}
                          className="btn btn-link "
                          data-toggle="tab"
                          tabIndex={0}
                          onClick={event => this.toggleServiceHealthNotesView()}
                        >
                          {'... '}
                          {ViewMore_text}
                        </button>
                      </div>
                    </td>
                  )}
                  {this.state.showFullStatusDescription && (
                    <td>
                      {this.props.service.statusDescription}{' '}
                      <button
                        id="showLessButton"
                        aria-label={ShowLessButtonServiceAnnouncementMessage_text}
                        style={{ padding: 0, border: 'none' }}
                        className="btn btn-link"
                        data-toggle="tab"
                        tabIndex={0}
                        onClick={event => this.toggleServiceHealthNotesView()}
                      >
                        {Showless_text}
                      </button>
                    </td>
                  )}
                </div>
              );
            } else if (this.props.service.status !== Constant.HealthStatus.Good)
              return this.props.service.statusDescription;
          })()}
        </td>
      </tr>
    );
    return tableRow;
  }
}

export default ServiceHealthStatus;
